import React from 'react'

import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core'

import { routes } from 'routes'
import Summary from './../Summary'
import Footer from './../Footer'
import CartItem from './components/CartItem'
import CartList from './components/CartList'
import useSubscribe from 'hooks/useSubscribe'
import useConfirmDialog from 'hooks/useConfirmDialog'
import useSnackbar from 'hooks/useSnackbar'

import styles from './styles'

const useStyles = makeStyles(styles)

const Cart = () => {
  const classes = useStyles()
  const history = useHistory()
  const subscribe = useSubscribe()
  const confirmDialog = useConfirmDialog()
  const snackbar = useSnackbar()

  const handleClickRemove = (event, item) => {
    confirmDialog.open({
      title: 'Remover item',
      message: `Deseja realmente remover o item ${item.name} do carrinho?`,
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
      handleConfirm: async e => {
        subscribe.removeItemCart(item)
        snackbar.open({
          message: 'Item removido com sucesso!',
          variant: 'success',
        })
      },
    })
  }

  const handleClickPrevButton = () => {
    history.push(routes.subscribe.main)
  }

  const handleClickNextButton = () => {
    subscribe.nextStep()
  }

  return (
    <div>
      <div className={classes.container}>
        <CartList className={classes.content}>
          {subscribe.cart.map((item, index) => (
            <CartItem
              item={item}
              key={`${item.id}${index}`}
              divider={index < subscribe.cart.length - 1}
              onClickRemove={handleClickRemove}
            />
          ))}
        </CartList>

        <Summary className={classes.summary} />
      </div>

      <Footer
        prevButtonText="Adicionar mais planos"
        prevButtonProps={{ onClick: handleClickPrevButton }}
        nextButtonProps={{
          disabled: !subscribe.cart.length,
          onClick: handleClickNextButton,
        }}
      />
    </div>
  )
}

export default Cart
